import React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export default function FailLandView(){

    const history = useHistory()

    // Redirect to login page when CCeP Portal Login failed
    const autoWebReload = () =>{
        window.alert("Go to Land failure, it will back to login page");
        history.push("/login")
    }

    useEffect(()=>{
        autoWebReload();
    });

    return (
        <div></div>
    )
}